import React, { useState } from "react";

export default function Textfield({
	name,
	value,
	onChange,
	type,
	maxLength = 36,
	className = "",
	placeholder,
	required = false,
	prefix,
	invalid,
	suffix,
	id,
	classNameParent,
	disabled = false,
	validation,
	error,
	autocomplete = "off",
	min,
	max,
	isNumberOnly = false, // Add this new prop
}) {
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword((prev) => !prev);
	};

	// Handle the input change with number validation if needed
	const handleInputChange = (e) => {
		if (isNumberOnly) {
			// Only allow numbers and decimal point
			const regex = /^[0-9]*\.?[0-9]*$/;
			if (e.target.value === "" || regex.test(e.target.value)) {
				onChange(e);
			}
		} else {
			onChange(e);
		}
	};

	return (
		<div className={`relative flex gap-2 ${classNameParent}`}>
			{prefix && <p className="my-auto mr-2">{prefix}</p>}
			<input
				id={id}
				type={showPassword ? "text" : type || "text"}
				className={`h-10 border-2 focus:outline-yellow-400 rounded-md p-1 ${
					className ? className : "w-full"
				}`}
				name={name}
				value={value}
				onChange={handleInputChange}
				maxLength={maxLength}
				invalid={invalid}
				placeholder={placeholder}
				required={required}
				disabled={disabled}
				{...validation}
				autoComplete={autocomplete}
				autoCorrect="off"
				autoCapitalize="off"
				spellCheck="false"
				list="autocompleteOff"
				aria-autocomplete="none"
				min={min}
				max={max}
			/>
			{type === "password" && (
				<span
					onClick={togglePasswordVisibility}
					className="cursor-pointer absolute right-2 top-1/2 transform -translate-y-1/2"
				>
					{showPassword ? (
						<i className="fas fa-eye"></i>
					) : (
						<i className="fas fa-eye-slash"></i>
					)}
				</span>
			)}
			{suffix}
			{error}
		</div>
	);
}
